import React, { useEffect, useState } from "react";
import axios from "axios";
import { testUrl } from "./BaseData";
import { useTranslation } from "react-i18next";
import classes from "./HomeGallery.module.css";
import AOS from "aos";

export const HomeGallery = () => {
    const [images, setImages] = useState([]);
    const { i18n } = useTranslation();

    useEffect(() => {
        axios.get(testUrl + "/api/home-gallery/")
            .then(res => setImages(res.data))
            .catch(err => console.error(err));

        AOS.init({ duration: 1000 });
    }, []);

    if (images.length === 0) return null;

    return (
        <section className={classes.gallerySection}>
            <div className={classes.container}>
                <div
                    className={classes.sectionHeader}
                    data-aos="fade-right"
                >
                    <h2 className={classes.sectionTitle}>{i18n.language === 'uz' ? 'Universitet hayoti' : i18n.language === 'ru' ? 'Жизнь университета' : 'University Life'}</h2>
                    <p className={classes.sectionSubtitle}>{i18n.language === 'uz' ? 'Bizning qiziqarli lahzalarimiz' : i18n.language === 'ru' ? 'Наши интересные моменты' : 'Our interesting moments'}</p>
                </div>
                <div className={classes.grid}>
                    {images.map((item, index) => (
                        <div
                            key={item.id}
                            className={classes.galleryItem}
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <img src={item.image} alt={item[`title_${i18n.language}`] || ""} />
                            {(item[`title_${i18n.language}`] || item.title_uz) && (
                                <div className={classes.overlay}>
                                    <h3>{item[`title_${i18n.language}`] || item.title_uz}</h3>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
